/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiServer } from '../../asyncapi/models/AaiServer';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';

/**
 * A command used to rename a security scheme, along with all references to it.
 * @author c.desc2@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class RenameServerCommand_Aai20 extends AbstractCommand {
    public _oldServerName : string;

    public _newServerName : string;

    public constructor(oldServerName? : any, newServerName? : any) {
        if(((typeof oldServerName === 'string') || oldServerName === null) && ((typeof newServerName === 'string') || newServerName === null)) {
            let __args = arguments;
            super();
            if(this._oldServerName===undefined) this._oldServerName = null;
            if(this._newServerName===undefined) this._newServerName = null;
            if(this._oldServerName===undefined) this._oldServerName = null;
            if(this._newServerName===undefined) this._newServerName = null;
            (() => {
                this._oldServerName = oldServerName;
                this._newServerName = newServerName;
            })();
        } else if(oldServerName === undefined && newServerName === undefined) {
            let __args = arguments;
            super();
            if(this._oldServerName===undefined) this._oldServerName = null;
            if(this._newServerName===undefined) this._newServerName = null;
            if(this._oldServerName===undefined) this._oldServerName = null;
            if(this._newServerName===undefined) this._newServerName = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameServerCommand_Aai20] Executing.");
        this._doServerRename(<Aai20Document>document, this._oldServerName, this._newServerName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameServerCommand_Aai20] Reverting.");
        this._doServerRename(<Aai20Document>document, this._newServerName, this._oldServerName);
    }

    /**
     * Does the work of renaming a path from one name to another.
     * @param {Aai20Document} document
     * @param {string} from
     * @param {string} to
     * @private
     * @private
     */
    /*private*/ _doServerRename(document : Aai20Document, from : string, to : string) {
        let aaiServer : AaiServer = null;
        if(ModelUtils.isDefined(document.servers)) {
            if(!this.isNullOrUndefined(/* get */((m,k) => m[k]===undefined?null:m[k])(document.servers, to))) {
                return;
            }
            aaiServer = /* remove */(map => { let deleted = document.servers[from];delete document.servers[from];return deleted;})(document.servers);
        }
        if(this.isNullOrUndefined(aaiServer)) {
            return;
        }
        aaiServer.rename(to);
        /* put */(document.servers[to] = aaiServer);
    }
}
RenameServerCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.RenameServerCommand_Aai20";
RenameServerCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




